import * as React from "react";
import "./searchDropDown.scss";
import {isNull, isNullOrUndefined} from "util";
import InputWithIcon from "../../atoms/Input/InputWithIcon";
import classNames = require("classnames");

interface IProps<T> {
	/**
	 * List of items.
	 */
	items: T[];
	/**
	 * Converts item to item label.
	 * @param {T} item
	 * @return {string}
	 */
	itemToLabel: (item: T) => string;
	/**
	 * Converts item to item id.
	 * @param {T} item
	 * @return {string}
	 */
	itemToId: (item: T) => string;
	/**
	 * On select callback.
	 * @param {string} id
	 */
	onSelect?: (item: T) => void;
	/**
	 * On input change callback.
	 */
	onChange?: (event: React.ChangeEvent<HTMLInputElement>) => void;
	/**
	 * Search input icon.
	 */
	searchInputIcon?: string;
	/**
	 * Search input placeholder.
	 */
	placeholder?: string;
	/**
	 * New option creator
	 * @param {string} inputText
	 * @returns {T}
	 */
	newOptionCreator: (inputText: string) => T
	/**
	 * Indicates if can create new options
	 */
	creatable?: boolean
}

interface IState<T> {
	/**
	 * List of filtered items.
	 */
	filteredItems: T[];
	/**
	 * Indicates if dropdown is visible.
	 */
	dropDownVisible: boolean;
	/**
	 * String to filter results on list.
	 */
	searchString: string;
	/**
	 * Item with focus
	 */
	itemWithFocus: T;
	/**
	 * New option
	 */
	newOption: T
}

export default class CreatableSearchDropDown<T> extends React.PureComponent<IProps<T>, IState<T>> {

	constructor(props: IProps<T>) {
		super(props);
		this.state = {
			dropDownVisible: false,
			filteredItems: this.props.items,
			searchString: "",
			itemWithFocus: this.props.items[0],
			newOption: null
		};
		this.filterList = this.filterList.bind(this);
		this.onSelect = this.onSelect.bind(this);
		this.onConfirm = this.onConfirm.bind(this);
	}

	render() {
		return (
			<div className={"m-search-dropdown"}>
				<div className={"m-search-dropdown_input"}>
					<InputWithIcon type={"text"}
								   value={this.state.searchString}
								   placeholder={this.props.placeholder}
								   appendIcon={this.props.searchInputIcon}
								   onChange={this.filterList}
								   focus={true}
								   onConfirm={this.onConfirm}/>
				</div>
				<ul>
					{!isNullOrUndefined(this.state.newOption) && (
						<li onClick={() => this.onSelect(this.state.newOption)} className={"is-focused"}>
							{this.props.itemToLabel(this.state.newOption)}
						</li>)}

					{this.state.filteredItems.map((item, index) => {
						return (
							<li key={index}
								onClick={() => this.onSelect(item)}
								onMouseOver={() => this.setState({itemWithFocus: item})}
								className={classNames({
									"is-focused": !isNullOrUndefined(this.state.itemWithFocus) &&
									this.props.itemToId(item) == this.props.itemToId(this.state.itemWithFocus)
								})}>
								{this.props.itemToLabel(item)}
							</li>
						);
					})}
				</ul>
			</div>
		);
	}

	filterList(evt: React.ChangeEvent<HTMLInputElement>) {
		const searchString = evt.target.value;
		const filteredItems = this.props.items.filter(
			(item: T) => this.props.itemToLabel(item).toLowerCase().indexOf(searchString.toLowerCase()) !== -1);
		let newOption: T = null;
		if (this.props.creatable && searchString.length) {
			newOption = this.props.newOptionCreator(searchString);
		}
		if (filteredItems.length) {
			if (!isNull(newOption)
				&& this.props.itemToId(filteredItems[0]) !== this.props.itemToId(newOption)) {
				this.setState({
					filteredItems: filteredItems, searchString, itemWithFocus: newOption, newOption
				})
			}
			else {
				this.setState({
					filteredItems: filteredItems, searchString, itemWithFocus: filteredItems[0], newOption: null
				})
			}
		}
		else {
			this.setState({
				filteredItems: filteredItems, searchString, itemWithFocus: newOption, newOption
			})
		}
	}

	/**
	 * On select callback.
	 * @param {T} item
	 */
	onSelect(item: T) {
		if (!isNullOrUndefined(this.props.onSelect)) {
			this.props.onSelect(item);
		}
	}

	/**
	 * On input enter press callback
	 */
	onConfirm() {
		if (!isNull(this.state.itemWithFocus)) {
			this.onSelect(this.state.itemWithFocus)
		}
	}
}
